<template>
    <BasePage>
        <div class="container mb-7">
            <h1 class="h2 mt-5 mb-0">Frequently asked questions</h1>
            <div v-if="loadError" class="card mt-5 py-6 px-3 text-center" role="alert">
                <h2>We couldn't load the questions</h2>
                <p>Please check your connection and try again.</p>
                <div><button type="button" class="btn btn-primary" @click="getFaqs()">Try again</button></div>
            </div>
            <div v-for="faq in faqs" v-bind:key="faq.faqId" class="card mt-4">
                <div class="card-header">
                    <h2 class="card-title">{{faq.faqTitle}}</h2>
                </div>
                <div class="card-body">
                    {{faq.faqText}}
                </div>
            </div>
        </div>
    </BasePage>
</template>

<script>
import api from '@/services/api'
import BasePage from '@/components/BasePage.vue';

export default {
    name: 'FAQPage',
    components: {
        BasePage,
    },
    data() {
        return {
            faqs: [],
            loadError: false
        }
    },
    mounted() {
        this.getFaqs();
    },
    methods: {
        // FE-14: a failed request shows a message and a retry instead of a blank page.
        async getFaqs() {
            this.loadError = false;
            try {
                const faqRes = await api.get('/api/faq');
                if (!Array.isArray(faqRes.data)) throw new Error('Unexpected reply');
                this.faqs = faqRes.data;
            } catch (e) {
                this.loadError = true;
            }
        }
    }
};
</script>
